import { render, staticRenderFns } from "./saleTaxTemplateCard.vue?vue&type=template&id=b4ede11e&scoped=true"
import script from "./saleTaxTemplateCard.vue?vue&type=script&lang=js"
export * from "./saleTaxTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./saleTaxTemplateCard.vue?vue&type=style&index=0&id=b4ede11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ede11e",
  null
  
)

export default component.exports